import {
  COMPUTED_ALLOCATION_ACCOUNTS,
  COMPUTED_ALLOCATION_ACCOUNT_ID,
  COMPUTED_ALLOCATION_ACCOUNT_FEES,
  COMPUTED_ALLOCATION_ACCOUNT_CODE,
  COMPUTED_ALLOCATION_ACCOUNT_AMOUNT,
  COMPUTED_ALLOCATION_ACCOUNT_AMOUNT_RAW,
  FORM_FIELD_ALLOCATION_SELECTED,
  FORM_FIELD_ALLOCATION_FEES,
  FORM_FIELD_ALLOCATION_DEPOSIT_TYPE,
  FORM_FIELD_ALLOCATIONS_AMOUNT_PERIODIC,
  FORM_FIELD_ALLOCATIONS_AMOUNT_CASH_INPUT,
  FORM_FIELD_ALLOCATIONS_AMOUNT_CASH_COMPUTED,
  FORM_FIELD_ALLOCATIONS_AMOUNT_EFT_INPUT,
  FORM_FIELD_ALLOCATIONS_AMOUNT_EFT_COMPUTED,
  FORM_FIELD_ALLOCATIONS_AMOUNT_TRANSFER,
  FORM_FIELD_ALLOCATION_FIRST_ACCOUNT,
  FORM_FIELD_ALLOCATION_INVESTMENT_ROUNDED,
  FORM_FIELD_ALLOCATION_EXISTING_INVESTMENT,
  FORM_FIELD_ALLOCATION_MAXIMUM_EXCEEDED,
} from '@/constants/engine';
import {SECTION_J_PLUS} from '@/constants/sections';
import {ValueResolver} from '@/engine/types';
import {recursiveReplaceIndex} from '@/engine/utils/object';
import {BatchUpdate} from '@/types/document/store';

export const cleanupAllocationForm = (updates: BatchUpdate[], valueResolver: ValueResolver) => {
  // Clean up all accounts
  const accountsCount = Number(valueResolver({$ref: `_${COMPUTED_ALLOCATION_ACCOUNTS}[count]`}));
  for (let i = 0; i < accountsCount; i++) {
    updates.push({type: 'unset', id: recursiveReplaceIndex(COMPUTED_ALLOCATION_ACCOUNT_ID, i)});
    updates.push({type: 'unset', id: recursiveReplaceIndex(COMPUTED_ALLOCATION_ACCOUNT_FEES, i)});
    updates.push({type: 'unset', id: recursiveReplaceIndex(COMPUTED_ALLOCATION_ACCOUNT_CODE, i)});
    updates.push({type: 'unset', id: recursiveReplaceIndex(COMPUTED_ALLOCATION_ACCOUNT_AMOUNT, i)});
    updates.push({type: 'unset', id: recursiveReplaceIndex(COMPUTED_ALLOCATION_ACCOUNT_AMOUNT_RAW, i)});
  }
  updates.push({type: 'set', id: `_${COMPUTED_ALLOCATION_ACCOUNTS}[count]`, value: '0'});

  // Remove the form values
  updates.push({type: 'unset', id: FORM_FIELD_ALLOCATION_SELECTED});
  updates.push({type: 'unset', id: FORM_FIELD_ALLOCATION_FEES});
  updates.push({type: 'unset', id: FORM_FIELD_ALLOCATION_DEPOSIT_TYPE});
  updates.push({type: 'unset', id: FORM_FIELD_ALLOCATIONS_AMOUNT_PERIODIC});
  updates.push({type: 'unset', id: FORM_FIELD_ALLOCATIONS_AMOUNT_CASH_INPUT});
  updates.push({type: 'unset', id: FORM_FIELD_ALLOCATIONS_AMOUNT_CASH_COMPUTED});
  updates.push({type: 'unset', id: FORM_FIELD_ALLOCATIONS_AMOUNT_EFT_INPUT});
  updates.push({type: 'unset', id: FORM_FIELD_ALLOCATIONS_AMOUNT_EFT_COMPUTED});
  updates.push({type: 'unset', id: FORM_FIELD_ALLOCATIONS_AMOUNT_TRANSFER});
  updates.push({type: 'unset', id: FORM_FIELD_ALLOCATION_FIRST_ACCOUNT});

  // Remove the warning flags
  updates.push({type: 'unset', id: FORM_FIELD_ALLOCATION_INVESTMENT_ROUNDED});
  updates.push({type: 'unset', id: FORM_FIELD_ALLOCATION_EXISTING_INVESTMENT});

  // Remove the error flags
  updates.push({type: 'unset', id: FORM_FIELD_ALLOCATION_MAXIMUM_EXCEEDED});

  // Clear validity
  updates.push({type: 'unset_validity', sectionId: SECTION_J_PLUS, fieldId: FORM_FIELD_ALLOCATION_SELECTED});
  updates.push({type: 'unset_validity', sectionId: SECTION_J_PLUS, fieldId: FORM_FIELD_ALLOCATION_FEES});
  updates.push({type: 'unset_validity', sectionId: SECTION_J_PLUS, fieldId: FORM_FIELD_ALLOCATION_DEPOSIT_TYPE});
  updates.push({type: 'unset_validity', sectionId: SECTION_J_PLUS, fieldId: FORM_FIELD_ALLOCATIONS_AMOUNT_PERIODIC});
  updates.push({type: 'unset_validity', sectionId: SECTION_J_PLUS, fieldId: FORM_FIELD_ALLOCATIONS_AMOUNT_CASH_INPUT});
  updates.push({type: 'unset_validity', sectionId: SECTION_J_PLUS, fieldId: FORM_FIELD_ALLOCATIONS_AMOUNT_EFT_INPUT});
  updates.push({type: 'unset_validity', sectionId: SECTION_J_PLUS, fieldId: FORM_FIELD_ALLOCATIONS_AMOUNT_TRANSFER});
};
